import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "checklist-item-wrapper" }
const _hoisted_2 = { class: "check-header" }
const _hoisted_3 = {
  key: 0,
  class: "check-title"
}
const _hoisted_4 = { class: "check" }
const _hoisted_5 = { class: "status hide" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "check-title" }
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "check-content" }

import { computed, ref } from "vue";
import { useStore } from "vuex";
import ApplicationChecklistSubItem from "@/components/ApplicationChecklistSubItem.vue";
import Income from "@/components/checklist/Income.vue";
import { StipulationStatusIds } from "@/config/constants";
import type { SortedCheckListItem } from "@/models/checklist";
import type { Applicant, Application } from "@/models/application";

interface Props {
  item: SortedCheckListItem;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationChecklistItem',
  props: {
    item: {}
  },
  emits: [
  "handleUploadSuccess",
  "incomeSourcesUpdated",
  "addressMismatchStipUpdated",
	"stipulationUpdated"
],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const store = useStore();
const showCheckbox = ref<boolean>(false);

const application = computed<Application>(() => store.state.appData?.application);
const applicant = computed<Applicant>(() => store.state.appData?.currentApplicant);
const active = computed<boolean>(() => props.item.status !== StipulationStatusIds.COMPLETED);
const complete = computed<boolean>(() => props.item.status === StipulationStatusIds.COMPLETED);
const pending = computed<boolean>(() => props.item.status === StipulationStatusIds.PENDING);
const showIncomeSourcesSelector = computed<boolean>(
  () => store.state.checklistModule?.showIncomeVerification === true,
);

const emit = __emit;

function toggleActive(e: any) {
  const item = e.target.parentElement.parentElement;
  if (item) {
    item.classList.toggle("active");
    if (item.classList.value.indexOf("active") > -1) {
      e.target.innerHTML = "-";
    } else {
      e.target.innerHTML = "+";
    }
  }
}

function getSubItemTitle(subitem: any) {
  if (
    subitem.processingCategoryName === "Identity" ||
    subitem.processingCategoryName === "SpousalConsent" ||
    subitem.processingCategoryName === "Income" ||
    subitem.processingCategoryName === "Citizenship"
  ) {
    return subitem.stipulationTypeDescription;
  } else {
    return props.item.formattedTitle;
  }
}

const status = computed<string>(() => {
  switch (props.item.status) {
    case StipulationStatusIds.PENDING:
      return "Pending Review";
    case StipulationStatusIds.COMPLETED:
      return "Complete!";
    default:
      return "Items Needed";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["checklist-item", { complete: complete.value, active: active.value, pending: pending.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (showCheckbox.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(complete.value ? "✓" : ""), 1),
              _createTextVNode(" " + _toDisplayString(__props.item.formattedTitle) + " ", 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(status.value), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(__props.item.formattedTitle) + " ", 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(status.value), 1)
              ])
            ])),
        (!complete.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "toggle",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleActive($event)))
            }, _toDisplayString(active.value ? "-" : "+"), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (__props.item?.title === 'Income Verification')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (showIncomeSourcesSelector.value === true)
                ? (_openBlock(), _createBlock(Income, {
                    key: 0,
                    applicant: applicant.value,
                    application: application.value,
                    onIncomeSourcesUpdated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('incomeSourcesUpdated')))
                  }, null, 8, ["applicant", "application"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.checklistModule.sortedApplicationStips[
                'Income Verification'
              ], (subitem, index) => {
                  return (_openBlock(), _createBlock(ApplicationChecklistSubItem, {
                    key: index,
                    subitem: subitem,
                    title: getSubItemTitle(subitem),
                    active: active.value,
                    itemComplete: __props.item.complete,
                    onHandleUploadSuccess: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('handleUploadSuccess', $event))),
                    onAddressMismatchStipUpdated: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('addressMismatchStipUpdated', $event)))
                  }, null, 8, ["subitem", "title", "active", "itemComplete"]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(store).state.checklistModule.sortedApplicationStips[
              __props.item.title
            ], (subitem, index) => {
              return (_openBlock(), _createBlock(ApplicationChecklistSubItem, {
                key: index,
                subitem: subitem,
                title: getSubItemTitle(subitem),
                active: active.value,
                itemComplete: __props.item.complete,
                onHandleUploadSuccess: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('handleUploadSuccess', $event))),
                onAddressMismatchStipUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('addressMismatchStipUpdated', $event))),
                onStipulationUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('stipulationUpdated', $event)))
              }, null, 8, ["subitem", "title", "active", "itemComplete"]))
            }), 128))
      ])
    ], 2)
  ]))
}
}

})